import { forwardRef } from "react"
import { ChevronsUpDown, Loader2, Users } from "lucide-react"
import { cn } from "@/lib/utils"

/**
 * Shared pill trigger for “which group am I in?” pickers (coach + member shells).
 * Styled with KF red tint so it reads as a control, not inline body text.
 *
 * Forwards ref + arbitrary props so Radix `DialogTrigger asChild` or manual
 * `onClick` openers both work reliably.
 */
export const GroupContextTrigger = forwardRef(function GroupContextTrigger(
  { groupName, busy, ariaLabel, className, ...props },
  ref,
) {
  return (
    <button
      ref={ref}
      type="button"
      aria-label={ariaLabel}
      aria-haspopup="dialog"
      disabled={busy}
      className={cn(
        "inline-flex align-middle items-center gap-2 max-w-full rounded-lg border border-kf-red/20 bg-kf-red/5",
        "px-3 py-1.5 text-left shadow-sm transition-colors",
        "hover:border-kf-red/35 hover:bg-kf-red/10",
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
        busy && "opacity-50 pointer-events-none",
        className
      )}
      {...props}
    >
      {busy ? (
        <Loader2 className="h-4 w-4 shrink-0 animate-spin text-kf-red/70" aria-hidden />
      ) : (
        <Users className="h-4 w-4 shrink-0 text-kf-red" aria-hidden />
      )}
      <span className="min-w-0 flex-1 text-sm font-semibold text-zinc-900 truncate max-w-[12rem] sm:max-w-[min(18rem,calc(100vw-14rem))]">
        {groupName}
      </span>
      <ChevronsUpDown className="h-4 w-4 shrink-0 text-kf-red/60" aria-hidden />
    </button>
  )
})
